import { createFeatureSelector, createSelector } from '@ngrx/store';

import { FEATURE_NAME } from './stripe-payment.constant';
import { StripePaymentsState } from './stripe-payment.model';

export const selectStripePaymentsState = createFeatureSelector<StripePaymentsState>(FEATURE_NAME);

export const selectStripePaymentStateByKey =
  (paymentKey: string) => createSelector(
    selectStripePaymentsState,
    (state) => state[paymentKey]
  );
